export const PASSWORD_VALIDATION = {
  minLength: 8,
  minUpperCaseCount: 1,
  minLowerCaseCount: 1,
  minDigitsCount: 1,
  minSpecialCharsCount: 1,
};

export const LOCKERS_SUGGEST_LIMIT = 300;
export const LOCKERS_SUGGEST_ORDER = "city,name";
